import React from "react";
import Helmet from "react-helmet";

import FormComprobante from "../../components/paet/FormComprobante";

export default function Comprobante() {

    return (
        <>
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <section>
                <div className="container">
                    <div className="card formulario mt-5 mb-5">
                        <div className="card-header">
                            <div className="form-row">
                                <div className="titulo">
                                    Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="subtitulo mt-3">
                                    ¡Tu solicitud ha sido ingresada!
                                </div>
                            </div>
                        </div>
                        <div className="card-body paet">
                            <FormComprobante />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}